const { fetchWithRetry } = require('./utils'); // Import fetchWithRetry  

// Function to create or update settings  
const createOrUpdateSettings = async (settings) => {
    try {
        const response = await fetchWithRetry('/api/settings', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(settings)
        });

        if (!response.ok) {
            throw new Error('Failed to save settings');
        }

        return await response.json();
    } catch (error) {
        console.error('Error saving settings:', error);
        throw error;
    }
};

// Function to get settings  
const getSettings = async (competitionId) => {
    try {
        const response = await fetchWithRetry(`/api/settings?competitionId=${competitionId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error('Failed to fetch settings');
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching settings:', error);
        throw error;
    }
};

// Function to update settings  
const updateSettings = async (settings, competitionId) => {
    try {
        const response = await fetchWithRetry(`/api/settings?competitionId=${competitionId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(settings)
        });

        if (!response.ok) {
            throw new Error('Failed to update settings');
        }

        return await response.json();
    } catch (error) {
        console.error('Error updating settings:', error);
        throw error;
    }
};

module.exports = {
    createOrUpdateSettings,
    getSettings,
    updateSettings
};  